import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44de887e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tategaki" }
const _hoisted_2 = { class: "lg" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = { class: "sm" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = {
  key: 0,
  class: "sm"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode("(問題)"),
      _hoisted_3,
      _createTextVNode(_toDisplayString(_ctx.plain_question), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createTextVNode("(解答)"),
      _hoisted_5,
      _createTextVNode(_toDisplayString(_ctx.answer), 1)
    ]),
    (_ctx.ex)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createTextVNode("(解説)"),
          _hoisted_7,
          _createTextVNode(_toDisplayString(_ctx.ex), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}